import React from 'react';
import moment from 'moment';
import LinerNotes from './liner-notes';
import { observer, inject } from 'mobx-react';
import autobind from 'autobind-decorator';

@inject('artistStore')
export default class Header
extends React.Component {
	constructor(props) {
		super(props);
		this.state = {opened: false};
	}
	calculateTotalTime () {
		const { album } = this.props;
		console.log(album.songs);
		let duration = album.songs.reduce((total, song) => {
			return song._duration + total;
		}, 0)
		return duration;
	}

	//time is in raw seconds
	convertTotalTime(time) {
		let hours = Math.floor(time / 3600);
		let minutes = Math.floor(time / 60);
		let seconds = Math.floor(time % 60);

		return hours > 0 ? `${hours} hr\t${minutes} min` : `${minutes} min\t${seconds} sec`;

	}
	render() {
		const { album, artistStore } = this.props;
		let artist = artistStore.getArtistByID(album.artistID);
		console.log(album);
		const imgSrc = album.artworkPath;

		const bgStyle = {
			backgroundImage: `url("${imgSrc}")`
		};

		let totalAlbumTime = this.calculateTotalTime();
		let convertedTime = this.convertTotalTime(totalAlbumTime);
		console.log(totalAlbumTime);

		if(artistStore.isLoading) {
			return null;
		}
		return (
			<div className="grid-x header-grid margin-left-3">
				<div className="cell shrink">
					<div className="image med-large" style={ bgStyle }></div>
				</div>
				<div className="margin-left-2 cell auto">
					<h2
						style={{ lineHeight: '1em ', fontSize: '4.8em', color: 'white' }}
						className="margin-top-2 padding-left-0 section-title artist"
					>
						{ album.name }
					</h2>
					<div className="margin-top-1 artist-name-banner small">
						{ artist.name }
					</div>
					<div className="artist-name-banner small">
						<div style={{textTransform: 'initial', width: '30vw', display:'flex' }}>
							<div>Released: 2020</div>
							<span className="padding-horizontal-1">|</span>
							<div>{album.songs.length} Tracks</div>
							<span className="padding-horizontal-1">|</span>
							<div>{convertedTime}</div>
						</div>
					</div>

					<div onClick={this.onReadMoreClick} className={this.state.opened ? 'modal-content liner-notes-wrapper' : 'liner-notes-wrapper'}>
						<LinerNotes album={album} opened={this.state.opened} onCloseClick={this.onCloseClick}/>
					</div>
				</div>
			</div>
		);
	}

	@autobind 
	onReadMoreClick () {
		console.log("State Changed")

		if(!this.state.opened) {
			this.setState((state, newState) => {
				return {
					opened: true
				}
			})
		}
	}

	@autobind 
    onCloseClick () {
        console.log("Close")
		if(this.state.opened) {
			this.setState((state, newState) => {
				return {
					opened: false
				}
			})
		}
    }
}
